import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Shared with kshyamgmanagementadmin so both apps use the same Firebase project.
const firebaseConfig = {
  apiKey: "AIzaSyAaC8plkp_O8CS6RfgTe689FF7E4k0MkmM",
  authDomain: "shyamgmanagement-ed446.firebaseapp.com",
  projectId: "shyamgmanagement-ed446",
  storageBucket: "shyamgmanagement-ed446.firebasestorage.app",
  messagingSenderId: "39488179786",
  appId: "1:39488179786:web:be77f3a2579ea5e8a260b3",
  measurementId: "G-7GHJ70QRDV",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const analyticsPromise = isSupported()
  .then((supported) => (supported ? getAnalytics(app) : null))
  .catch(() => null);

export default app;
